import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { OSR_REPORT_QUERY } from '../../../graphql.js'
import { Button, Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData, getInputParams, sortColumnClicked } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'

const OSR_REPORT = gql(OSR_REPORT_QUERY)

export default function OSRReport({ location }) {
  console.log('OSRReport rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, OSR_REPORT, 'osrReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    results.reportInfo.columnHeadings.push('')
    const canModify = results.modifyActionId ? true : false
    if (canModify) {
      results.reportInfo.columnHeadings.push('')
    }
    const resultRows = []
    let row = []
    for (let i = 0; i < results.reportData.length; i++) {
      let modifyButtonColumn = canModify ? <td><Link to={`/object/${results.reportData[i][17]}?actionId=${results.modifyActionId}&source=${location.pathname}${location.search}`}><Button className={results.reportData[i][17]} color="warning" size="sm">Modify</Button></Link></td> : ''
      for (let j = 0; j < results.reportData[i].length - 1; j++) {
        if (j === results.reportData[i].length - 2) {
          row.push(<td key={j}><Link to={`/object/${results.reportData[i][j]}?source=${location.pathname}${location.search}`}><Button className={results.reportData[i][j]} color="primary" size="sm">View</Button></Link></td>)
        } else if (j === 0) {
          row.push(<td key={-1}><b>{i + 1}</b></td>)
          row.push(<td key={0}>{results.reportData[i][j]}</td>)
        } else {
          row.push(<td key={j}>{results.reportData[i][j]}</td>)
        }
      }
      resultRows.push(<tr key={i}>{row}{modifyButtonColumn}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Custom/osrReport/osr_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered className="custom-table">
          <ReportHeading title={'Outstanding Research Chart'} parameterValues={ParameterValues(results.reportInfo)} />
          <tbody>
            <ColumnHeadings results={results.reportInfo} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}